var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNiliveryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 17,
    viewBox: "0 0 96 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7435 14.937C13.7435 14.937 2.80914 12.0874 0.0548539 0C0.0548539 0 -1.34814 11.6248 9.92752 16.9527H13.747V14.9337L13.7435 14.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.628 2.41074V17H16.3015V2.41074H19.628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4952 2.41074V14.12H32.9342V17.0034H22.1687V2.41074H25.4952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8531 2.41074V17H34.5266V2.41074H37.8531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6131 2.41074L48.7288 17H45.1472L39.2629 2.41074H43.0272L47.0845 13.151L51.1246 2.41074H54.6166H54.6131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0232 2.41074H67.0989V5.24013H59.3497V8.21133H66.4577V11.0407H59.3497V14.174H67.2644V17.0034H56.0232V2.41074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2677 17L75.379 12.398H72.7281V17H69.4016V2.41074H75.3962C79.1812 2.41074 81.3908 4.37916 81.3908 7.40438C81.3908 9.40994 80.4222 10.9496 78.6676 11.7531L82.1216 16.9966H78.2643L78.2677 17ZM72.7316 9.51799H75.2549C77.0095 9.51799 78.0712 8.78531 78.0712 7.40438C78.0712 6.02345 77.0095 5.29078 75.2549 5.29078H72.7316V9.51461V9.51799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4257 12.4183V17H87.0992V12.4183L81.5251 2.41074H85.3274L88.909 9.3019L92.4733 2.41074H95.9998L90.4257 12.4183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0551758 7.02283V16.9764H3.32309V13.026C1.67534 11.0677 0.665323 8.96424 0.0551758 7.02283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7437 14.0795V2.41074H10.4758V12.658C12.0133 13.5055 13.2473 13.9275 13.7437 14.0795Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiliveryLogo);
export default __webpack_public_path__ + "static/media/niliveryLogo.479d2e24de50d0377b7f437238db07de.svg";
export { ForwardRef as ReactComponent };